import { Component } from '@angular/core';
import { TypeMerchantUserEnum } from 'app/models';

@Component({
    selector: 'partner-employees-root',
    templateUrl: './partner-employees-root.component.html',
    styleUrls: ['./partner-employees-root.component.scss']
})
export class PartnerEmployeesRootComponent {
    public employeesMenuEnum = TypeMerchantUserEnum;
    public activeMenuItem: TypeMerchantUserEnum = TypeMerchantUserEnum.StoreEmployees;

    public onMenuItemClick(item: TypeMerchantUserEnum) {
        this.activeMenuItem = item;
    }
}
